import { cmsGraphQLClient } from '@app/graphQLClient';
import { Layout } from '@components/Layout';
import SingleBoat from '@components/SingleBoat/index';
import { getBoatName } from '@utils/getBoatName';
import { GetServerSideProps } from 'next';
import { AntMessageProvider, AntNotificationProvider } from 'providers';
import React, { useMemo } from 'react';
import { Boat, GetBoatBySlug, GetBoatBySlugVariables, useGetBoatBySlug } from 'services/graphql/cms';
import { queryClient } from 'services/queryClient';

type Props = {
  slug: string;
  boat: Boat;
};

const SingleBoatPage: React.FC<Props> = ({ boat }) => {
  const title = useMemo(() => {
    const boatTitle = getBoatName(boat);

    if (boatTitle.includes('null')) {
      return 'Boat';
    }

    return boatTitle;
  }, [boat]);

  const metaData = {
    title: boat?.seo?.metaTitle || title,
    description: boat?.seo?.metaDescription ? boat?.seo?.metaDescription : boat?.description,
    image: boat?.seo?.metaImage?.url || boat?.image?.url,
    robots: boat?.seo?.metaRobots ? boat?.seo?.metaRobots : 'index, follow',
  };

  return (
    <AntMessageProvider>
      <AntNotificationProvider>
        <Layout meta={metaData}>
          <main>
            <SingleBoat boat={boat} />
          </main>
        </Layout>
      </AntNotificationProvider>
    </AntMessageProvider>
  );
};

export const getServerSideProps: GetServerSideProps = async ({ params }) => {
  const slug: string = params.slug as string;

  const variables: GetBoatBySlugVariables = {
    slug,
  };

  const fetchedBoats = await queryClient.ensureQueryData<GetBoatBySlug>({
    queryKey: ['getPublicBoatBySlug', variables],
    queryFn: useGetBoatBySlug.fetcher(cmsGraphQLClient, variables),
  });

  if (fetchedBoats?.boats?.length) {
    return {
      props: {
        boat: fetchedBoats.boats[0],
        slug,
      },
    };
  }

  return {
    notFound: true,
  };
};

export default SingleBoatPage;
